import { getSortedFields, useFocusedField } from '@wix/form-fields';
import { useCallback } from 'react';
export const useScrollToFirstError = ({ form, handleStepChange, currentStepId })=>{
    const { setFocusedFieldId } = useFocusedField();
    const scrollToFirstError = useCallback((errors)=>{
        const sortedFieldsInStep = getSortedFields(form, {
            stepId: currentStepId
        });
        const fieldWithError = sortedFieldsInStep?.find((_field)=>{
            return errors.some((error)=>_field.target === error.errorPath.split('/')[0]);
        });
        setFocusedFieldId(fieldWithError?.id);
    }, [
        currentStepId,
        form,
        setFocusedFieldId
    ]);
    const handleScrollToFirstError = useCallback((errors)=>{
        const sortedFields = getSortedFields(form);
        const field = sortedFields?.find((_field)=>{
            return errors.some((error)=>_field.target === error.errorPath.split('/')[0]);
        });
        if (Number(form.steps?.length) > 0) {
            const fieldStep = form.steps?.find((step)=>{
                const fieldInStep = step.layout?.large?.items?.find((layoutField)=>layoutField.fieldId === field?.id);
                return Boolean(fieldInStep);
            });
            const fieldStepIndex = fieldStep && form.steps?.indexOf(fieldStep);
            if (typeof fieldStepIndex !== 'undefined' && fieldStep?.id !== currentStepId) {
                handleStepChange(fieldStepIndex);
            }
        }
        if (errors.length > 0) {
            setFocusedFieldId(field?.id);
        }
    }, [
        form,
        currentStepId,
        handleStepChange,
        setFocusedFieldId
    ]);
    return {
        scrollToFirstError,
        handleScrollToFirstError
    };
};

//# sourceMappingURL=use-scroll-to-first-error.js.map